module.exports = __webpack_public_path__ + "img/advantage_03.1d16e8c7.png";